import AddAssetsButtonDirective from './assets/add/add-assets-button';
import AddUsersButtonDirective from './add-users/add-users-button';
import CancelButtonDirective from './cancel/cancel-button';
import CreateButtonDirective from './create/create-button';
import DeleteButtonDirective from './delete/delete-button';
import EditButtonDirective from './edit/edit-button';
import ExportCsvButtonDirective from './export-csv/export-csv-button';
import RemoveSelectedButtonDirective from './remove-selected/remove-selected-button';
import SaveButtonDirective from './save/save-button';
import SelectAssetsButtonDirective from './assets/select/select-assets-button';
import TableOrderButtonsDirective from './table/order/table-order-buttons';
import TableRemoveButtonDirective from './table/remove/table-remove-button';
import ToggleButtonComponent from './toggle-button/toggle-button';

const componentsButtonModule = angular.module('app.components.buttons', []);
componentsButtonModule
	// Directives
	.directive('addAssetsButton', AddAssetsButtonDirective)
	.directive('addUsersButton', AddUsersButtonDirective)
	.directive('cancelButton', CancelButtonDirective)
	.directive('createButton', CreateButtonDirective)
	.directive('deleteButton', DeleteButtonDirective)
	.directive('editButton', EditButtonDirective)
	.directive('exportCsvButton', ExportCsvButtonDirective)
	.directive('removeSelectedButton', RemoveSelectedButtonDirective)
	.directive('saveButton', SaveButtonDirective)
	.directive('selectAssetsButton', SelectAssetsButtonDirective)
	.directive('tableOrderButtons', TableOrderButtonsDirective)
	.directive('tableRemoveButton', TableRemoveButtonDirective)

	// Components
	.component('toggleButton', ToggleButtonComponent);

export default componentsButtonModule.name;
